module.exports = __webpack_public_path__ + "images/oscarb13cf3a87e1c82ba665cc322d70e3463.png";